import {reducerAndActionsFor} from '../../helpers/helpers';
import {api} from '@symbolic/lib';
import {combineReducers} from 'redux';
import _ from 'lodash';
import {singularize} from 'inflection';

require('henrybuilt-js-library');

var lib = window.lib;

var reducerAndActionsByResource = lib.object.fromKeys(['nodes', 'edges', 'actions'], pKey => {
  var sKey = singularize(pKey);

  var actionKeyFor = (action, key) => _.camelCase(`${action}-${_.kebabCase(key)}`)

  var stateFor = ({byId}) => {
    var state = {byId};

    if (pKey === 'edges') state.parentMap = _.keyBy(byId, node => `${node.fromNodeId}-${node.toNodeId}`);

    return state;
  };

  return reducerAndActionsFor(`resources.${pKey}`, {
    [actionKeyFor('track', pKey)]: async ({params, getState, ...arg}) => {
      var resources = arg[pKey];
      var oldResources = _.get(getState(), `resources.${pKey}.byId`);
      var byId = {...oldResources, ..._.keyBy(resources, 'id')}

      return stateFor({byId});
    },
    [actionKeyFor('create', sKey)]: async ({props, getState}) => {
      var resource = await api.create(sKey, _.omit(props, ['id']));

      var oldResources = _.get(getState(), `resources.${pKey}.byId`);
      var byId = {...oldResources, [resource.id]: resource};

      return stateFor({byId});
    },
    [actionKeyFor('update', sKey)]: async ({id, props, getState}) => {
      await api.update(sKey, {where: {id}, props});

      var oldResources = _.get(getState(), `resources.${pKey}.byId`);
      var oldProps = oldResources[id];
      var byId = {...oldResources, [id]: {...oldProps, ...props}};

      return stateFor({byId});
    },
    [actionKeyFor('destroy', sKey)]: async ({id, getState}) => {
      await api.destroy(sKey, {where: {id}});

      var oldResources = _.get(getState(), `resources.${pKey}.byId`);
      var byId = _.omit(oldResources, [id + '']);

      return stateFor({byId});
    }
  });
});

var resourcesReducer = combineReducers(_.mapValues(reducerAndActionsByResource, 'reducer'));
var resourceActions = _.mapValues(reducerAndActionsByResource, 'actions');

export default resourcesReducer;
export {resourceActions};
